export default __webpack_public_path__ + "media/images/icons/xrp-0bc7b16400b8b2e0ec00d33ca8a875d0.png";